import { render, staticRenderFns } from "./AdjustStock.vue?vue&type=template&id=6fa0971b&scoped=true&"
import script from "./AdjustStock.vue?vue&type=script&lang=js&"
export * from "./AdjustStock.vue?vue&type=script&lang=js&"
import style0 from "./AdjustStock.vue?vue&type=style&index=0&id=6fa0971b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa0971b",
  null
  
)

export default component.exports